import { mkdir, writeFile } from "node:fs/promises";
import { join } from "node:path";
import { generateStorefrontLogo } from "../../lib/storefront-logo.js";
import type { Brand } from "./brand.js";

export async function writeStorefrontLogo(target: string, brand: Brand): Promise<{ path: string; source: string }> {
  const logo = await generateStorefrontLogo({
    name: brand.name,
    accent: brand.colors.accent,
    tagline: brand.tagline,
  });
  const dir = join(target, "public", "brand");
  await mkdir(dir, { recursive: true });
  const svgPath = join(dir, "logo.svg");
  await writeFile(svgPath, logo.svg, "utf8");
  if (logo.pngBase64) {
    await writeFile(join(dir, "logo.png"), Buffer.from(logo.pngBase64, "base64"));
  }
  return { path: svgPath, source: logo.source };
}
